<div class="w-full">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center flex-1 overflow-hidden">
      <h6 mat-dialog-title class="font-semibold primary-font w-full truncate" [title]="dialogTitle">{{(type === 'RESCHEDULE' ? 'text.reschedule' : 'text.schedule') | translate}} - {{dialogTitle}}</h6>
    </div>
    <div class="flex items-center mr-1 min-w-fit flex-0">
      <span (click)="closeJobScheduleDate()" class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
    <!-- permission warning -->
    <div class="rounded-md bg-red-50 m-4 mb-0 px-4 py-3 border-l-8 border-red-500" *ngIf="!isScheduleAllowed">
      <div class="flex items-center">
          <div class="flex-shrink-0"><em class="ti ti-alert-circle text-red-500 text-2xl"></em></div>
          <div class="ml-3 flex-1 md:flex md:justify-between">
              <p *ngIf="type==='SCHEDULE'" class="text-base text-red-500">{{'job.schedule.permission.warning' | translate}}</p>
              <p *ngIf="type==='RESCHEDULE'" class="text-base text-red-500">{{'job.reschedule.permission.warning' | translate}}</p>
          </div>
      </div>
  </div>  
  <div class="flex flex-col zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
    <div>
      <form [formGroup]="updateJobScheduleForm" class="cancelForm h-full overflow-y-none" autocomplete="off">
        <div class="grid grid-cols-1 gap-x-4 mb-4" *ngIf="utilityService.isTimeZoneEnabled || (utilityService.isTimeZoneEnabled === false && jobDetails?.job_timezone && type==='RESCHEDULE')">
              <div class="time-zone-drop-down-schedule flex items-center justify-between" 
              [ngClass]="{'pointer-events-none disabled opacity-70': utilityService.isTimeZoneEnabled === false}"
              >
                  <i class="ti ti-world text-2xl mr-2 mt-1 text-gray-600"></i>
                  <ng-select class="w-full mt-1 border-l-0" [disabled]="utilityService.isTimeZoneEnabled === false"
                      [formControlName]="'job_timezone'" [items]="timeZoneData" [placeholder]="'text.choose_timezone' | translate"
                      bindValue="key" bindLabel="display_name" [searchFn]="timezoneService.customTimezoneSearch"
                      [clearable]="false" [multiple]="false" [hideSelected]="true">
                  </ng-select>
              </div>
              <div class="flex items-center pointer-events-none" *ngIf="utilityService.isTimeZoneEnabled === false && jobDetails?.job_timezone && type==='RESCHEDULE'" >
                <i class="ti ti-info-circle text-xl mr-2 text-red-500"></i>
                <span class="text-md text-red-500">
                 {{'text.clear_timezone_info' | translate}}
                </span>
              </div>
        </div>
        <div class="grid grid-cols-2 gap-x-4">
          <div class="flex flex-col w-full mb-4">
            <div>
              <label for="startTime" class="block text-base font-medium mb-2 text-gray-700 required">{{'text.scheduled_start_time' | translate}}</label>
            </div>
            <div class="grid grid-cols-2 gap-x-4 ">
              <mat-form-field appearance="fill" ngClass="w-full" [floatLabel]="'always'">
                <input type="text" matInput id="field_value" name="field_value" class="form-control" [matDatepicker]="picker" [datePickerFormat]="dateFormat" (focus)="picker?.open()" name="from_date" formControlName="from_date" placeholder="{{'text.choose_date' | translate}}"
                [min]="dateValidationRanges.minStartDate"
                [max]="dateValidationRanges.maxStartDate" readonly
                >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" ngClass="w-full" [floatLabel]="'always'">
                <input matInput id="from_time_field" name="from_time_field" class="form-control" formControlName="from_time_field" placeholder="{{'text.pick_time' | translate}}"
                  [matMenuTriggerFor]="menu"
                  readonly />
                  <button mat-icon-button matSuffix [matMenuTriggerFor]="menu">
                        <mat-icon
                        [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <div class="flex flex-col">
                        <div class="flex justify-center">
                            <ngx-mat-timepicker (click)="$event.stopPropagation()"
                            formControlName="from_time_picker" 
                            [disabled]="false"
                            [showSpinners]="true"
                            [stepHour]="1" [stepMinute]="fromTimeStepper"
                            [showSeconds]="false"
                            [enableMeridian]="getMeridian()">
                            </ngx-mat-timepicker>
                        </div>
                    </div>
                </mat-menu>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-col gap-x-4 w-full mb-4">
            <div>
              <label for="reason" class="block text-base font-medium mb-2 text-gray-700 required">{{'text.scheduled_end_time' | translate}}</label>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field appearance="fill" ngClass="w-full" [floatLabel]="'always'">
                <input type="text" matInput id="field_value" name="field_value" class="form-control" [min]="updateJobScheduleForm?.controls?.from_date?.value" [matDatepicker]="toDatePicker" [datePickerFormat]="dateFormat" (focus)="toDatePicker?.open()" name="to_date" formControlName="to_date" placeholder="{{'text.choose_to_date' | translate}}"
                [min]="dateValidationRanges.minEndDate"
                [max]="dateValidationRanges.maxEndDate" readonly
                >
                <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #toDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" ngClass="w-full" [floatLabel]="'always'">
                <input matInput id="to_time_field" name="to_time_field" class="form-control" formControlName="to_time_field" placeholder="{{'text.pick_time' | translate}}"
                  [matMenuTriggerFor]="toMenu"
                  readonly />
                  <button mat-icon-button matSuffix [matMenuTriggerFor]="toMenu">
                        <mat-icon
                        [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                  </button>
                  <mat-menu #toMenu="matMenu">
                    <div class="flex flex-col">
                        <div class="flex justify-center">
                            <ngx-mat-timepicker (click)="$event.stopPropagation()"
                            formControlName="to_time_picker" 
                            [disabled]="false"
                            [showSpinners]="true"
                            [stepHour]="1" [stepMinute]="toTimeStepper"
                            [showSeconds]="false"
                            [enableMeridian]="getMeridian()">
                            </ngx-mat-timepicker>
                        </div>
                    </div>
                </mat-menu>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-1 gap-x-4 mb-4" *ngIf="updateJobScheduleForm.controls.job_timezone.value !== '' && utilityService.isTimeZoneEnabled" >
            <div class="rounded-md text-black bg-gray-100 p-2 flex items-center" >
              <span class="text-base text-gray-700" >
                <b>{{fromTimeInAccountTimeZone | datetime :
                  utilityService.dateFormat}} 
                  {{fromTimeInAccountTimeZone | timeformat}} 
                  -> 
                  {{toTimeInAccountTimeZone | datetime :
                      utilityService.dateFormat}}
                      {{toTimeInAccountTimeZone | timeformat}} 
                </b> {{'text.account.timezone' | translate}}
              </span>
            </div>
        </div>
        <div *ngIf="updateJobScheduleForm?.controls?.from_date?.value && updateJobScheduleForm?.controls?.to_date?.value && showStartEndDateError()" class="mb-2">
          <p class="text-red-500 text-base">{{'reschedule.start.end.date.error.message' | translate}}</p>
        </div>
        <div class="mb-2" *ngIf="jobDetails?.due_date">
          <p class="text-red-500 text-base">{{getDueDateErrorMessage()}}</p>
        </div>
        <div class="mb-2" *ngIf="projectWarning.show">
          <p class="text-red-500 text-base">{{projectWarning.msg}}</p>
        </div>
        <div class="mb-2" *ngIf="routeWarning.show">
          <p class="text-red-500 text-base">{{routeWarning.msg}}</p>
        </div>
        <div class="mb-2" *ngIf="showClearScheduleAlert">
          <p class="text-red-500 text-base">{{'reschedule.clear_schedule.error.message' | translate}}</p>
        </div>
        <div class="mb-2" *ngIf="data?.showTaskAlert">
          <span class="flex items-center text-red-500 text-base" *ngIf="data?.serviceTaskDuration?.days || data?.serviceTaskDuration?.hours || data?.serviceTaskDuration?.minutes">
            {{"label.service_task_duration" | translate}}
            <i class="ti ti-arrow-narrow-right mx-1 text-base"></i>
            <i class="ti ti-clock text-base"></i>
            <span class="px-2">
                <span *ngIf="data?.serviceTaskDuration?.days" class="mx-0.5">{{data?.serviceTaskDuration?.days}}d</span>
                <span *ngIf="data?.serviceTaskDuration?.hours" class="mx-0.5">{{data?.serviceTaskDuration?.hours}}h</span>
                <span *ngIf="data?.serviceTaskDuration?.minutes" class="mx-0.5">{{data?.serviceTaskDuration?.minutes}}m</span>
            </span>
          </span>
        </div>
        <div class="w-full mt-2 mb-4" *ngIf="type === 'edit'">
          <div class="mr-4">
            <label for="reason" class="block text-base font-medium mb-2 text-gray-700">{{'reason.for.update.job.schedule' | translate}}</label>
            <textarea 
              class="border border-gray-300 rounded-md p-3" 
              style="width: 100%;" 
              name="reason" 
              formControlName="reason"
              id="reason" 
              cols="40">
            </textarea>
          </div>
        </div>
        <div class="grid grid-cols-2" *ngIf="showRemoveJob()">
          <div class="w-full flex items-center space-x-2">
            <input
                type="checkbox"
                id="update" [(ngModel)]="removeJob" [ngModelOptions]="{standalone: true}" (change)="checkJobWarnings()"/>
            <label for="update" class="font-medium text-gray-700 cursor-pointer" >{{getRouteMessage | translate}}</label>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="rescheduledJobsArr.length === 0 && maintainIntervel && module === 'PROJECT_LIST_VIEW'" class="zuper-dialog-body pt-6 pl-6 primary-font items-center border-t border-gray-300 primary-font text-base">
    <p class="mb-4">{{ 'text.project.job.reschedule.intervel.title' | translate }}</p>
    <div class="mb-4 flex items-center text-base font-medium">
      <input type="radio" id="NONE" name="NONE" class="mr-2" [(ngModel)]="maintainIntervelType" value="NONE">
      <label for="option1" class="font-base">{{ 'text.project.job.reschedule.intervel.option1' | translate }}</label>
    </div>
    <div class="mb-4 flex items-center text-base font-medium">
      <input type="radio" id="MAINTAIN" name="MAINTAIN" class="mr-2" [(ngModel)]="maintainIntervelType" value="MAINTAIN">
      <label for="option2" class="font-base">{{ 'text.project.job.reschedule.intervel.option2' | translate }}</label>
    </div>
  </div>
  <div *ngIf="rescheduledJobsArr.length > 0 && module === 'PROJECT_LIST_VIEW'" class="zuper-dialog-body pt-6 pl-6 primary-font items-center border-t border-gray-300 primary-font text-base">
    <div class="bg-orange-100 border-l-4 primary-font  border-orange-500 text-orange-600 p-2" role="alert">
      <p class="font-bold">{{'text.project.job.reschedule.intervel.warning' | translate}}</p>
    </div>
    <div class="w-full mt-4  max-height-dependency-jobs overflow-y-auto zuper-scrollbar">
      <div *ngFor="let job of rescheduledJobsArr" class="flex justify-between items-center border-b border-gray-300 py-2">
        <div class="flex items-center">
          <span class="text-sm primary-font font-normal mr-2">{{ job.job_title }}</span>
        </div>
        <div class="flex items-center">
          <span class="text-sm primary-font font-normal line-through mr-2">
            {{ job.scheduledStartDate }} -> {{ job.scheduledEndDate }}
          </span>
          <span class="text-sm primary-font font-normal">
            {{ job.rescheduledStartDate }} -> {{ job.rescheduledEndDate }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="rounded-md  m-4 mb-2 px-4 py-3 border-l-8 border border-orange-500" *ngIf="maintainIntervel && module === 'PROJECT_GANTT_VIEW' && jobDetails?.dependency">
    <div class="flex items-center">
        <div class="flex-shrink-0"><em class="ti ti-alert-circle text-orange-500 text-2xl"></em></div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
            <p class="text-base text-orange-500">{{'text.project.phase.dependency.reschedule.warning' | translate}}</p>
        </div>
    </div>
</div>  
  <div class="flex items-center border-t border-gray-300 zuper-dialog-footer">
    <div *ngIf="type === 'RESCHEDULE' && enableClearSchedule">
      <button class="px-3 text-base" mat-button (click)="clearSchedule()">
          <span class="cursor-pointer text-primary">{{'text.clear_schedule' | translate}}</span>
      </button>
    </div>
    <div class="ml-auto flex space-x-4 bg-gray-50">
        <button type="button" (click)="closeJobScheduleDate()" mat-stroked-button class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text' | translate}}</button>
        <button *ngIf="!maintainIntervel" (click)="updateJobScheduleDate()" class="min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary"
          [disabled]="disableReschedule || !isScheduleAllowed">{{'update' | translate}}
        </button>
        <button *ngIf="maintainIntervel" (click)="proceedIntervelMaintainance()" class="min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary"
        [disabled]="disableReschedule || !isScheduleAllowed">{{rescheduleBtnTitle | translate}}
      </button>
    </div>
  </div>
</div> 